import { create } from 'zustand';
import { api } from './api';

const useUserStore = create((set, get) => ({
  users: [],
  loading: false,
  error: null,

  fetchUsers: async () => {
    set({ loading: true, error: null });
    try {
      const response = await api.get('/api/users');
      set({ users: response.data, loading: false });
    } catch (error) {
      set({
        error: error.response?.data?.error || 'Failed to fetch users',
        loading: false
      });
    }
  },

  createUser: async (userData) => {
    set({ loading: true, error: null });
    try {
      const response = await api.post('/api/users', userData);
      set((state) => ({
        users: [...state.users, response.data],
        loading: false
      }));
      return response.data;
    } catch (error) {
      set({
        error: error.response?.data?.error || 'Failed to create user',
        loading: false
      });
      throw error;
    }
  },

  updateUser: async (userId, updates) => {
    set({ loading: true, error: null });
    try {
      const response = await api.put(`/api/users/${userId}`, updates);
      set((state) => ({
        users: state.users.map(u => u.id === userId ? response.data : u),
        loading: false
      }));
      return response.data;
    } catch (error) {
      set({
        error: error.response?.data?.error || 'Failed to update user',
        loading: false
      });
      throw error;
    }
  },

  deleteUser: async (userId) => {
    set({ loading: true, error: null });
    try {
      await api.delete(`/api/users/${userId}`);
      set((state) => ({
        users: state.users.filter(u => u.id !== userId),
        loading: false
      }));
    } catch (error) {
      set({
        error: error.response?.data?.error || 'Failed to delete user',
        loading: false
      });
      throw error;
    }
  },

  updateUserRole: async (userId, role) => {
    set({ loading: true, error: null });
    try {
      const response = await api.put(`/api/users/${userId}/role`, { role });
      set((state) => ({
        users: state.users.map(u => u.id === userId ? response.data : u),
        loading: false
      }));
      return response.data;
    } catch (error) {
      set({
        error: error.response?.data?.error || 'Failed to update user role',
        loading: false
      });
      throw error;
    }
  },

  clearError: () => set({ error: null }),
}));

export default useUserStore;
